<template>
    <section class="course container">
        <div class="row justufy-content-center">
            <div class="col-12 mb-3">
                <button type="button" class="btn btn-primary" @click="toggleModal()">
                    <font-awesome-icon icon="plus" /> Agregar
                </button>
                <button type="button" class="btn btn-primary" @click="toggleTemplateDefaultEmail()">
                  Plantilla Default
                </button>
            </div>
            <div class="col-12 col-md-12 col-lg-12">
                <ListCourses />
            </div>

            <!-- Modal add new course -->
            <ModalAddCourse />
            <!-- Modal Managers -->
            <ModalManagers />
            <ModalTemplateDefault/>
        </div>
    </section>
</template>

<script>
import ListCourses from "@/components/ListCourses.vue"
import ModalAddCourse from "@/components/ModalAddCourse.vue"
import ModalManagers from "@/components/modals/Managers.vue"
import ModalTemplateDefault from "@/components/DefaultTemplate.vue"

export default {
    name: "Courses",
    data(){
      return {
      }
    },
    methods: {
        addCourses() {
            this.$store.commit("setCourseAction", "add")
            this.$store.dispatch("toggleModalAddCourse")
        },
        toggleModal() {
            this.$store.commit("setCourseAction", "add")
            this.$store.dispatch("toggleModalAddCourse")
        },
        toggleTemplateDefaultEmail() {
          this.$store.dispatch("toggleTemplateDefaultEmail")
        },
        setData(){
          this.showModalv = !this.showModalv;
        }
    },
    components: {
        ListCourses,
        ModalTemplateDefault,
        ModalAddCourse,
        ModalManagers
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Courses.vue